import { useState } from "react";

export default function useBookTutorForSubjectContextValue() {
  const [bookTutorForSubject, setBookTutorForSubject] = useState<string>();

  const contextValue = {
    bookTutorForSubject,
    setBookTutorForSubject: (subject?: string) =>
      setBookTutorForSubject(subject)
  };

  return contextValue;
}
